/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Hero_TitleInputs */

const en_cp_hero_title = /** @type {(inputs: Cp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One semester. One real product. Evidence at every step.`)
};

const id_cp_hero_title = /** @type {(inputs: Cp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu semester. Satu produk nyata. Bukti di tiap langkah.`)
};

/**
* | output |
* | --- |
* | "One semester. One real product. Evidence at every step." |
*
* @param {Cp_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_hero_title = /** @type {((inputs?: Cp_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_hero_title(inputs)
	return en_cp_hero_title(inputs)
});